import { RootState } from '../store'

export const devicesState = (state: RootState) => state.devices
